import { RelativeDate } from "../baseTypes";

export type AudienceSourceId = string;
export type AudiencBaselineId = string;

export type AudienceSettings = {
  audience: AudienceSourceId;
  baseline: AudiencBaselineId;
  dateFilter: RelativeDate;
};

export type AudienceSourcesFromApi = {
  accounts: { id: string; name: string }[];
  networks: { id: string; name: string }[];
};

export type AudienceType = "segment" | "network";

export type AudienceOptionItem = {
  value: string;
  label: string;
  type: AudienceType;
  weighting?: string;
};
export type AudienceGroup = { group: string; items: AudienceOptionItem[] };
export type AudienceOption = AudienceOptionItem | AudienceGroup;
export type AudienceOptions = AudienceOption[];

type SpaceTrait = {
  label: string;
  attUri: string;
  scoreUri: string;
};

export type SpaceAxis = {
  label: string;
  traits: SpaceTrait[];
};

export type Space = {
  label: string;
  axes: SpaceAxis[];
};

export type Spaces = Space[];

export type AudienceComparisonParams = AudienceSettings & {
  audienceType?: AudienceType;
  attUri: string;
  scoreUri: string;
  weighting?: string;
};

export type AudienceComparisonResult = {
  baseline: number;
  scores: number[];
  indexes: number[] | null;
  confidence: number | null;
};

/**
 * The types of values that can appear in a cell within the results table.
 */
export type AudienceComparisonCellData =
  | { kind: "loading" }
  | {
      kind: "success";
      value: number;
      scorePct: number | null;
      baselinePct: number | null;
    }
  | {
      kind: "alert";
      value: number;
      scorePct: number | null;
      baselinePct: number | null;
      confidencePct: number | null;
    }
  | { kind: "n-a" }
  | { kind: "error"; message?: string };

export const audienceComparisonColumns = ["index", "composition"] as const;

export type AudienceComparisonColumn =
  (typeof audienceComparisonColumns)[number];
